import { Edge, Node } from '@xyflow/react';
import { AllFlowNodes } from '../Nodes/types';

// This function checks if a node of type `sourceNodeType` is connected to the selected node
// used for validating if a sensor node is connected to an action node
export const findNodeConnection = ({
  selectedNode,
  sourceNodeType,
  nodes,
  edges,
}: {
  selectedNode: AllFlowNodes;
  sourceNodeType: string;
  nodes: Node[];
  edges: Edge[];
}): false | { found: true; sourceNodeId: string } => {
  const map = new Map<string, string>();
  nodes.forEach((node) => {
    if (typeof node.id === 'string' && typeof node.type === 'string') {
      map.set(node.id, node.type);
    }
  });

  // Recursively check if any previous node in the chain was sourceNodeType
  function findTypeInChain(
    nodeId: string,
    visited = new Set<string>(),
  ): false | { found: true; sourceNodeId: string } {
    if (visited.has(nodeId)) return false;
    visited.add(nodeId);

    const type = map.get(nodeId);
    if (type === sourceNodeType) return { found: true, sourceNodeId: nodeId };

    // Find all incoming edges to this node
    const incomingEdges = edges.filter((edge) => edge.target === nodeId);
    for (const edge of incomingEdges) {
      const result = findTypeInChain(edge.source, visited);
      if (result) return result;
    }
    return false;
  }

  return findTypeInChain(selectedNode.id);
};
